<template>
  <el-card class="box-card">
    <template #header>
      <div class="card-header">
        <el-page-header content="新增公司" @back="$router.back()" />
      </div>
    </template>
    <el-steps :active="active" simple finish-status="success" style="margin-bottom: 30px">
      <el-step title="公司信息"></el-step>
      <el-step title="知识产权"></el-step>
    </el-steps>
    <Company :company="company" :isNew="true" @saveSuccess="next" v-if="active===0"/>
    <Property :companyId="company.cId" :isNew="true" v-if="active===1&&company.cId>0"/>
  </el-card>
</template>

<script>
import Company from '../components/company.vue'
import Property from '../components/property.vue'
export default {
  components: {
    Company,
    Property
  },
  data () {
    return {
      company: {
        name: null,
        cType: null,
        fr: null,
        zczb: null,
        xydm: null,
        zs: null,
        yyqx: null,
        jyfw: null,
        fcrq: null,
        clrq: null,
        jzrq: null,
        cId: 0
      },
      active: 0
    }
  },
  created () {
    if (!sessionStorage.getItem('jId')) {
      this.$router.push('/login').then()
    }
  },
  methods: {
    next (res) {
      this.company.cId = res
      if (this.active++ > 2) this.active = 0
    }
  }
}
</script>

<style scoped>
.box-card {
  width: calc(100% - 4rem - 2px);
  min-height: calc(100% - 4rem - 2px);
  margin: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/add.vue